/**
 * @generated SignedSource<<83468076ee84bb3084198ff2053bd160>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type GuildMembershipLevel = "EDITOR" | "MEMBER" | "ORGANIZER" | "%future added value";
export type GuildTypes = "GUILD" | "NETWORK" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EventOwnerPickerGuildOption_guild$data = {
  readonly myMembership: {
    readonly membershipLevel: GuildMembershipLevel;
  } | null | undefined;
  readonly name: string;
  readonly networks: {
    readonly nodes: ReadonlyArray<{
      readonly myMembership: {
        readonly membershipLevel: GuildMembershipLevel;
      } | null | undefined;
      readonly name: string;
    } | null | undefined>;
  };
  readonly type: GuildTypes | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"GuildPrimaryPhotoNew_guild">;
  readonly " $fragmentType": "EventOwnerPickerGuildOption_guild";
};
export type EventOwnerPickerGuildOption_guild$key = {
  readonly " $data"?: EventOwnerPickerGuildOption_guild$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventOwnerPickerGuildOption_guild">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "GuildMembership",
  "kind": "LinkedField",
  "name": "myMembership",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "membershipLevel",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventOwnerPickerGuildOption_guild",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": "networks",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 20
        },
        {
          "kind": "Literal",
          "name": "membershipStatus",
          "value": "ACCEPTED"
        }
      ],
      "concreteType": "GuildsConnection",
      "kind": "LinkedField",
      "name": "rankedNetworks",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Guild",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": "rankedNetworks(first:20,membershipStatus:\"ACCEPTED\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GuildPrimaryPhotoNew_guild"
    }
  ],
  "type": "Guild",
  "abstractKey": null
};
})();

(node as any).hash = "ce622fa4fb1112f6b22fb795e92cdc66";

export default node;
